import { useExportEnableLayerPickerV2 } from '~/hooks/useExportEnableLayerPickerV2';
import { LayerPickerLegacy } from './LayerPickerLegacy';
import { LayerPickerV2 } from './LayerPickerV2';
import type { LayerPickerProps } from './pickerRows';

export { LAYER_SEARCH_INPUT_ID } from './LayerPickerV2';

export const DownloadLayerPicker = (props: LayerPickerProps) => {
  const pickerV2Enabled = useExportEnableLayerPickerV2();
  return pickerV2Enabled ? <LayerPickerV2 {...props} /> : <LayerPickerLegacy {...props} />;
};
